import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    ...sharedConfig['de-DE'].seo,
  },
  MDXContent: content as DocumentTypes,
};
